const FLOATING_CHAT_HIDDEN_ROUTE_ROOTS = ['/grants'];

export const shouldHideFloatingChat = (pathname) =>
  FLOATING_CHAT_HIDDEN_ROUTE_ROOTS.some(
    (routeRoot) =>
      pathname === routeRoot || pathname.startsWith(`${routeRoot}/`),
  );
